import { ExtendedSlot, Slot } from "../model/Slot";

export function getMonthsArray(){
  const months = Array.from({length: 12}, (item, i) => {
  return new Date(0, i).toLocaleString('fr-FR', {month: 'short'})
});

const currentMonth = new Date().getMonth();
const lastYearMonths = months.slice(currentMonth+1)
const thisYearMonth = months.slice(0, currentMonth+1)

return lastYearMonths.concat(thisYearMonth)
}


function checkSlot(slot: Slot, currentHour: number) {
  return parseInt(slot.endTime.slice(0, 2), 10) - currentHour
}

export function displayNextSlot(slots: Slot[]) {
    if (slots.length === 1){
      return slots.at(0)
    }

    const now = new Date();
    const currentHour = now.getHours()
    const slotsWithClosenessArray: ExtendedSlot[] = slots.map(slot => ({
      ...slot,
      closeness: checkSlot(slot, currentHour)
    }))

    const validSlot = slotsWithClosenessArray.filter(slot => slot.closeness >= 0)

    // S'il existe un service à venir c'est ce dernier qui est affiché, sinon c'est le dernier service du jour qui est à l'affiche
    if (validSlot.length > 0) {
      const nextSlot = validSlot.reduce<ExtendedSlot | null>((closestSlot, currentSlot) => {
        if (currentSlot.closeness >= 0) {
          if (closestSlot === null || currentSlot.closeness < closestSlot.closeness) {
            return currentSlot
          }
        }
        return closestSlot
      }, null)
      return nextSlot
    } 
      if (validSlot.length === 0) {
        return slots[slots.length - 1]
      }
    return slots.at(0)
  }